import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SectionHeader } from "@/components/common/Ornament";
import ContentTab from "@/components/admin/ContentTab";
import PhotosTab from "@/components/admin/PhotosTab";
import DocumentsTab from "@/components/admin/DocumentsTab";
import FinancialsTab from "@/components/admin/FinancialsTab";
import PresetsTab from "@/components/admin/PresetsTab";
import CompsTab from "@/components/admin/CompsTab";
import DisclaimerTab from "@/components/admin/DisclaimerTab";
import SecurityTab from "@/components/admin/SecurityTab";
import LogsTab from "@/components/admin/LogsTab";

const TABS = [
  ["content", "Content", ContentTab], ["photos", "Photos & Plans", PhotosTab], ["docs", "Documents", DocumentsTab],
  ["financials", "Baseline Financials", FinancialsTab], ["presets", "Preset Scenarios", PresetsTab], ["comps", "Comparable Sales", CompsTab],
  ["disclaimer", "Disclaimer", DisclaimerTab], ["passwords", "Passwords", SecurityTab], ["logs", "Access Log", LogsTab],
];

export default function Admin() {
  return (
    <div>
      <SectionHeader eyebrow="Administrator" title="Admin Dashboard" testId="admin-header">Everything you change here is saved to the database and shown to viewers immediately.</SectionHeader>
      <Tabs defaultValue="content">
        <div className="overflow-x-auto -mx-1 px-1 pb-1">
          <TabsList className="h-auto bg-white border border-[#E2DCD2] p-1 inline-flex w-max">
            {TABS.map(([id, label]) => (
              <TabsTrigger key={id} value={id} className="data-[state=active]:bg-[#0F2E23] data-[state=active]:text-[#F9F6F0] px-3 py-2 text-sm" data-testid={`admin-tab-${id}`}>{label}</TabsTrigger>
            ))}
          </TabsList>
        </div>
        {TABS.map(([id, , C]) => (
          <TabsContent key={id} value={id} className="mt-6"><C /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
